"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useAccessory = require("../../../../hooks/upsell/useAccessory");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const getColorOptions = colors => {
  return colors.map(color => {
    const [colorValue, colorName] = color.split('|');
    return {
      text: colorName,
      value: colorValue,
      color: colorValue
    };
  });
};
const getSizeOptions = sizes => {
  return sizes.map(size => {
    const [sizeValue, sizeUnit] = size.split('|');
    return {
      text: `${sizeValue} ${sizeUnit}`,
      value: sizeValue
    };
  });
};
const VariancePicker = () => {
  const {
    selectionTree,
    currentVariant,
    handleVariantChange
  } = (0, _useAccessory.useAccessory)();
  const colors = getColorOptions(Object.keys(selectionTree.colors));
  const sizes = getSizeOptions(selectionTree.colors[Object.keys(selectionTree.colors)[0]]);
  const initialColor = colors.find(color => currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.color.includes(color.value)) || colors[0];
  const initialSize = sizes.find(size => currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.size.includes(size.value)) || sizes[0];
  const [currentColor, setCurrentColor] = (0, _react.useState)(initialColor.value);
  const [currentSize, setCurrentSize] = (0, _react.useState)(initialSize.value);
  const [sizeOptions, setSizeOptions] = (0, _react.useState)(sizes);
  const handleColorChange = color => {
    setCurrentColor(color);
    const colorKey = Object.keys(selectionTree.colors).find(key => key.includes(color));
    const options = getSizeOptions(selectionTree.colors[colorKey]);
    setSizeOptions(options);
    setCurrentSize(options[0].value);
    handleVariantChange(color, options[0].value);
  };
  const handleSizeChange = size => {
    setCurrentSize(size);
    handleVariantChange(currentColor, size);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSelectWithLabel, {
    fieldWrapper: {
      label: `Select Color`,
      width: 'full'
    },
    colorSelect: {
      id: `smartwatch-color`,
      value: currentColor,
      onChange: handleColorChange,
      options: colors
    }
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SelectInputWithMenuWithLabel, {
    fieldWrapper: {
      label: `Select Size`,
      width: 'full'
    },
    selectInputWithMenu: {
      id: `smartwatch-size`,
      required: true,
      value: currentSize,
      onChange: handleSizeChange,
      options: sizeOptions
    }
  })));
};
var _default = VariancePicker;
exports.default = _default;